import { RouteRecordRaw } from "vue-router";
import Agreement from "@/views/home/join/Agreement.vue";
import Genuine from "@/views/home/join/Genuine.vue";
import Required from "@/views/home/join/Required.vue";
import PlayerOptional from "@/views/home/join/option/player/PlayerOptional.vue";
import CenterOptional from "@/views/home/join/option/centers/CenterOptional.vue";
import PlannerOptional from "@/views/home/join/option/planner/PlannerOptional.vue";
import Complete from "@/views/home/join/Complete.vue";
import SelectRole from "@/views/home/join/select-role/SelectRole.vue"
import { blockPage } from "@/services";

// R2 Player -> players
// R2 Center -> centers
// R2 Planner -> planners
const routes: Array<RouteRecordRaw> = [
  {
    alias: [""],
    path: "select-role",
    component: SelectRole,
  },
  {
    path: "agreement/:role", // 약관 동의
    component: Agreement,
  },
  {
    path: "genuine/:role", // 이메일 인증
    component: Genuine,
  },
  {
    path: "required/:role", // 필수 정보 입력
    component: Required,
  },
  {
    path: "optional/players", // 플레이어 선택 정보 입력
    component: PlayerOptional,
  },
  {
    path: "optional/centers", // 센터 선택 정보 입력
    component: CenterOptional,
  },
  {
    path: "optional/planners", // 플래너 선택 정보 입력
    component: PlannerOptional,
  },
  {
    path: "complete/:role",
    component: Complete,
  },
];

export default routes;
